import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useWebSocket } from '../hooks/useWebSocket';
import { WS_URL } from '../config';

export default function AuthLinks() {
  const { user, logout } = useAuth();
  const [query, setQuery] = useState('');
  const navigate = useNavigate();
  const data = useWebSocket(WS_URL);

  const handleSearch = (e) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/search?q=${encodeURIComponent(query.trim())}`);
      setQuery('');
    }
  };

  const activeUsers = (data?.type === 'playback_update' && data.active_users)
    ? [...data.active_users].sort((a, b) => a.username.localeCompare(b.username))
    : [];

  return (
    <div className="mt-6 space-y-4 text-sm">
      <form onSubmit={handleSearch} className="flex items-center space-x-2">
        <input
          type="text"
          placeholder="Search songs..."
          className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <button
          type="submit"
          className="px-2 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          🔍
        </button>
      </form>

      <Link to="/" className="block text-indigo-600 hover:underline">
        <img src="/emoji/1F3B6.svg" className="inline w-4 h-4 mr-1" />
        Queue
      </Link>

      <Link to="/artists" className="block text-purple-600 hover:underline">
        <img src="/emoji/1F9D1-200D-1F3A8.svg" className="inline w-4 h-4 mr-1" />
        Artists
      </Link>

      <Link to="/platform" className="block text-purple-600 hover:underline">
        <img src="/emoji/1F4C7.svg" className="inline w-4 h-4 mr-1" />
        Platforms
      </Link>
      
      <Link to="/tags" className="block text-teal-600 hover:underline">
        <img src="/emoji/1F3F7.svg" className="inline w-4 h-4 mr-1" />
        Tags
      </Link>

      {user ? (
        <>
          <Link to="/profile" className="block text-blue-700 hover:underline">
            <img src="/emoji/1F464.svg" className="inline w-4 h-4 mr-1" />
            {user.username}
          </Link>
          {/* Show Add Song link for helpers only */}
          {user.role === 'helper' || user.role === 'moderator' || user.role === 'admin' ? (
            <Link to="/addsong" className="block text-green-700 hover:underline">
              <img src="/emoji/1F3B6.svg" className="inline w-4 h-4 mr-1" />
              Add Song
            </Link>
          ) : null}
          <button
            onClick={logout}
            className="block text-red-600 hover:underline"
          >
            <img src="/emoji/1F6AA.svg" className="inline w-4 h-4 mr-1" />
            Log Out
          </button>
        </>
      ) : (
        <>
          <Link to="/login" className="block text-blue-600 hover:underline">
            <img src="/emoji/1F6AA.svg" className="inline w-4 h-4 mr-1" />
            Log In
          </Link>
          <Link to="/signup" className="block text-green-600 hover:underline">
            <img src="/emoji/1F918.svg" className="inline w-4 h-4 mr-1" />
            Sign Up
          </Link>
        </>
      )}

      {activeUsers.length > 0 && (
        <div className="mt-4">
          <p className="text-xs text-gray-500 mb-1">
            <img src="/emoji/1F465.svg" className="inline w-4 h-4 mr-1" />
            Active Users
          </p>
          <ul className="space-y-1 text-xs text-gray-700">
            {activeUsers.map((u) => (
              <li key={u.username}>• {u.username}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
